module.exports = __webpack_public_path__ + "img/en.b407870f.png";